import { BeneficiaryInsightDimension } from '@repo/shared/dtos/beneficiary'
import { useT } from '@repo/ui/hooks'
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '@repo/ui/select'

import { FormType } from '../../types'

export function SelectModeButton({
  form,
  dimensionIndex,
}: {
  form: FormType
  dimensionIndex: number
}) {
  const { t } = useT({ keyPrefix: 'admin.insights.form.dimensions.buckets.date' })

  const mode = form.watch('dimensionModes')[dimensionIndex]!.date ?? 'simple'

  const updateMode = (mode: 'simple' | 'range' | 'timeseries') => {
    const dimensionModes = form.getValues('dimensionModes')
    const dimension = form.getValues('dimensions')[dimensionIndex]
    dimensionModes[dimensionIndex]!.date = mode
    form.setValue('dimensionModes', [...dimensionModes])
    if (mode === 'timeseries') {
      form.setValue(`dimensions.${dimensionIndex}`, {
        ...dimension,
        buckets: [],
      } as unknown as BeneficiaryInsightDimension)
    } else {
      form.setValue(`dimensions.${dimensionIndex}`, {
        ...dimension,
        timeSeries: undefined,
      } as unknown as BeneficiaryInsightDimension)
    }
  }
  return (
    <Select
      value={mode}
      onValueChange={(value) => updateMode(value as 'simple' | 'range' | 'timeseries')}
    >
      <SelectTrigger>
        <SelectValue placeholder={t('modePlaceholder')} />
      </SelectTrigger>
      <SelectContent>
        <SelectItem value="simple">{t('modeOptions.simple')}</SelectItem>
        <SelectItem value="range">{t('modeOptions.range')}</SelectItem>
        <SelectItem value="timeseries">{t('modeOptions.timeseries')}</SelectItem>
      </SelectContent>
    </Select>
  )
}
